import { pricingPath } from '.';

export const developerPath = () => {
  return `/developer`;
};

export const systemStatusPath = () => {
  return 'https://jicoostatus.com';
};

export const developerApiWebhookPath = (locale?: string | null | undefined) => {
  return developerCenterDocPath(locale === 'ja' ? 351325 : 356016);
};

export const developerApiAccountPath = (locale?: string | null | undefined) => {
  return developerCenterDocPath(locale === 'ja' ? 356017 : 356022);
};

export const developerCenterPath = () => `https://developer.jicoo.com`;
export const developerCenterDocPath = (id: string | number) => {
  return `${developerCenterPath()}/doc-${id}`;
};
export const developerCenterApiReferencePath = () => {
  return developerCenterDocPath(356044);
};
// export const developerCenterPath = () => `https://q853vlcotq.apidog.io`;
